namespace TabAurous.Retail {
    export interface GiftVoucherIssueForm {
        VoucherNo: Serenity.StringEditor;
        TransDate: Serenity.DateEditor;
        GiftMasterId: Serenity.LookupEditor;
        Quantity: Serenity.IntegerEditor;
        ItemDetails: GiftVoucherItemDetailsEditor;
    }

    export class GiftVoucherIssueForm extends Serenity.PrefixedContext {
        static formKey = 'Retail.GiftVoucherIssue';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!GiftVoucherIssueForm.init)  {
                GiftVoucherIssueForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.LookupEditor;
                var w3 = s.IntegerEditor;
                var w4 = GiftVoucherItemDetailsEditor;

                Q.initFormType(GiftVoucherIssueForm, [
                    'VoucherNo', w0,
                    'TransDate', w1,
                    'GiftMasterId', w2,
                    'Quantity', w3,
                    'ItemDetails', w4
                ]);
            }
        }
    }
}
